import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import { useEffect, useState, useContext, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Navigation } from 'swiper';
import { MediaContext } from '../../util/mediaContext';

let globalToken = "DefaultToken";
let globalURL = "DefaultURL";


const EmblaCarousel = ( props ) => {
  
  useEffect(() => {
    try {
      console.log("HomeSightJs");
  
      // Safely access window and HomeSightJs
      if (
        typeof window !== "undefined" &&
        window.HomeSightJs &&
        typeof window.HomeSightJs.getUserDataServiceName === "function" &&
        typeof window.HomeSightJs.getService === "function"
      ) {
        const userDataServiceName = window.HomeSightJs.getUserDataServiceName();
        const userDataService = window.HomeSightJs.getService(userDataServiceName);
  
        const deviceUuid = userDataService?.getDeviceUuid?.();
        const baseUrl = userDataService?.getBaseUrl?.();
  
        if (!deviceUuid || !baseUrl) {
          console.warn("Missing deviceUuid or baseUrl");
          return;
        }
  
        console.log("deviceUuid", deviceUuid);
        console.log("baseUrl", baseUrl);
  
        const apiUrl = `${baseUrl}hacloud/api/v1/user/${deviceUuid}/resources/photos?details=true`;
        console.log("apiUrl", apiUrl);
  
        // Get access token safely
        const provisioningServiceName = window.HomeSightJs.getProvisioningServiceName?.();
        const provisioningService = window.HomeSightJs.getService?.(provisioningServiceName);
        const accessToken = provisioningService?.getAccessToken?.();
  
        if (!accessToken) {
          console.warn("Access token not found");
          return;
        }
  
        console.log("accessToken", accessToken);
  
        // Call your state updater
        setTokenAndUUID(accessToken, apiUrl);
      } else {
        console.warn("HomeSightJs not available or missing required methods");
      }
    } catch (error) {
      console.error("Error in HomeSightJs useEffect:", error);
    }
  }, []);
  
  const { setSlideCount } = useContext(MediaContext);

  const [apiImages, setApiImages] = useState([]);
  const [jsonImages, setJsonImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const swiperRef = useRef(null);
  const fullScreenRef = useRef( null );

  const preloadImages = (imageUrls) => {
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  };

  const fetchPhotos = async (url) => {
    try {
      console.log("url", url)
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${globalToken}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });

      if (!response.ok) throw new Error('Failed to fetch API images');

      const data = await response.json();
      console.log('Fetched API images:', data);

      if (!data || !data.info || data.info.length === 0) {
        console.log('Cloud API returned empty data');
        throw new Error('Empty data from API');
      }

      const imageUrls = data.info.map((item) => item.url).filter(Boolean);
      console.log('Processed image URLs:', imageUrls);

      setApiImages(imageUrls);
      preloadImages(imageUrls);
      setLoading(false);
    } catch (error) {
      console.error('Error loading API photos:', error);
      setError(true);
      fetchJsonImages();
    }
  };

  const fetchJsonImages = () => {
    fetch('/common/photos/photos.json')
      .then((response) => response.json())
      .then((data) => {
        if (data && data.info) {
          const imageUrls = data.info.map((item) => item.url).filter(Boolean);
          console.log('Fetched JSON images:', imageUrls);
          setJsonImages(imageUrls);
          preloadImages(imageUrls);
        } else {
          console.error('No valid image data found in JSON');
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error loading JSON photos:', error);
        setLoading(false);
        setError(true);
      });
  };

  // 🔧 Call API fetch only if token and UUID are already set
  useEffect(() => {
    if (globalToken !== 'DefaultToken' && globalURL !== 'globalURL') {
      fetchPhotos(globalURL);
    }
  }, []);

  // Global functions for external control
  function setTokenAndUUID(token, url) {
    globalToken = token || "DefaultToken";
    globalURL = url || "DefaultUUID";

    console.log(`Token: ${globalToken}, UUID: ${globalURL}`);

    fetchPhotos(globalURL);
  };


  window.slideLeft = () => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  window.slideRight = () => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const enterFullScreen = () => {
    if (fullScreenRef.current?.requestFullscreen) {
      fullScreenRef.current.requestFullscreen();
    } else if (fullScreenRef.current?.webkitRequestFullscreen) {
      fullScreenRef.current.webkitRequestFullscreen();
    }
  };

  const imagesToDisplay = apiImages.length ? apiImages : jsonImages;

  if (loading) {
    return <div></div>;
  }

  if (error && imagesToDisplay.length === 0) {
    return <div style={{ color: 'white', textAlign: 'center' }}>Failed to load images.</div>;
  }

  return (
    <div 
      ref={fullScreenRef}
      style={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        width: '100vw', 
        height: '100vh', 
        cursor: 'pointer'
      }}
      onClick={enterFullScreen}
    >
      <Swiper
        ref={swiperRef}
        modules={[EffectFade, Autoplay, Navigation]}
        effect="fade"
        fadeEffect={{
          crossFade: true
        }}
        loop={true}
        loopAdditionalSlides={1}
        autoplay={{
          delay: 15000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        }}
        speed={300}
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        {imagesToDisplay.map((image, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#000',
              }}
            >
              {image && (
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  onError={(e) => {
                    console.error(`Error loading image: ${image}`, e);
                    e.target.src = '/common/photos/default-placeholder.jpg';
                  }}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    transition: 'transform 0.1s',
                  }}
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EmblaCarousel;